import type { FreshnessState } from './models.js';

const PHONE_FRESHNESS_LABELS: Record<FreshnessState, string> = {
  current: 'Акт.',
  aging: 'Стар.',
  stale: 'Стар.',
  source_error: 'Ош.',
  missing: 'Нет',
  unknown: 'Неизв.',
};

export function phoneFreshnessLabel(state: FreshnessState): string {
  return PHONE_FRESHNESS_LABELS[state];
}
